

import Image from 'next/image'
import styles from './ua.module.scss'
import Button from '@/components/button/Button'

export default function AdContent(props) {
  
  const ad = props.ad
  
  return <>
    <Image src={ad.background_image} alt={"Ad"} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: "cover" }} priority={false} sizes={'1600x1600'}></Image>
    <div className={styles.backdrop}></div>
    <div className={ styles.message + ' ' + styles['message-v-' + ad.vertical_align] + ' ' + styles['message-h-' + ad.horizontal_align] }>
      <div>
        <div>
          { ad.header?.text &&
          <div className={styles['ad-text-' + ad.header.size] + ' ' + styles['ad-text-' + ad.header.style] + ' ' + styles['ad-text-color-' + ad.header.color]}>
            { ad.header.text }
          </div>
          }
          { ad.message?.text &&
          <div className={styles['ad-text-' + ad.message.size] + ' ' + styles['ad-text-' + ad.message.style] + ' ' + styles['ad-text-color-' + ad.message.color]}>
            { ad.message.text }
          </div>
          }
        </div>
        <div>
          <Button mapping={ad.button.url_type} label={ad.button.label} theme={['inline', ad.button.theme]}></Button>
        </div>
      </div>
    </div>
  </>
  
  
}